import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import { useBuscarLeadInterface } from "interfaces";
import React, { useEffect } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import warn from "../../../../../../constants/toast";
import * as IconSVG from "../../../../../../assets/iconsSVG";
import { AuthState } from "../../../../../../store/ducks/auth/types";
import * as Styles from "./styles";

interface CorretorProps {
  label: string;
  value: string;
}

interface Props {
  setModalIsOpen: () => void;
  isLoadingDataCorretores: boolean;
  corretoresEmpresaVendas: any;
  IdProduto: string | null | undefined;
  sendData: any;
  corretorSelected: (val: CorretorProps | null) => void;
  disabled?: boolean;
}

const FormHorizontalSearch = (props: Props) => {
  const { plantaoVendas, supervisorProduto }: any = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const { plantaoVendas: pdvSelected } = usePlantaoVendas();

  const corretoresOptions = props.corretoresEmpresaVendas ?? null;
  const [nome, setNome] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [corretor, setCorretor] = React.useState<any>(null);
  const [inputCorretorValue, setInputCorretorValue] = React.useState("");

  const paramsBuscarLead: useBuscarLeadInterface = {
    IdCorretor: corretor?.value ?? "",
    NomeLead: nome,
    TelefoneLead: phone,
    EmailLead: email,
    IdPdv: supervisorProduto ? pdvSelected?.value : plantaoVendas?.id,
  };

  const handleSendForm = () => {
    if (corretor && (email.length > 0 || phone.length > 0)) {
      props.setModalIsOpen();
      props.sendData(paramsBuscarLead);
    } else {
      warn.wargingError(
        "Informe o corretor do visitante e ao menos um meio de contato dele!"
      );
    }
  };

  useEffect(() => {
    props.corretorSelected(corretor);
  }, [corretor]);

  function isValidInput(text: string) {
    // Expressão regular para verificar se o texto contém apenas letras e acentos
    const regex = /^[^0-9!@#$%^&*()-=+|\\/?;'"`<>]*$/;
    return regex.test(text);
  }

  const handleChange = (event: any) => {
    const inputValue = event.target.value;
    if (isValidInput(inputValue)) {
      setNome(inputValue);
    }
  };

  return (
    <Styles.Section>
      <Styles.Bar>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconSVG.UserIcon />
              </InputAdornment>
            ),
            disableUnderline: true,
            inputProps: {
              maxLength: 100,
            },
          }}
          onChange={handleChange}
          value={nome}
          variant="standard"
          placeholder="Nome"
          size="small"
          fullWidth
        />
        <hr />
        <Styles.InputPhone
          dropdownStyle={{ borderRadius: 8 }}
          buttonStyle={{
            border: "none",
            margin: 6,
            backgroundColor: "transparent",
          }}
          value={phone}
          onChange={(event3) => {
            setPhone(event3);
          }}
          inputStyle={{
            borderWidth: 1,
            paddingTop: 3,
            width: "100%",
            height: 41,
            borderColor: "#D0D5DD",
          }}
          masks={{ br: "(..) .....-...." }}
          country="br"
        />
        <hr />

        <TextField
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconSVG.MailOutlineIcon />
              </InputAdornment>
            ),
            disableUnderline: true,
          }}
          onChange={(event) => {
            setEmail(event.target.value);
          }}
          placeholder="E-mail"
          fullWidth
        />
        <hr />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <InputAdornment position="start">
            <IconSVG.UserIcon />
          </InputAdornment>
          <Autocomplete
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                border: "none",
                borderRadius: "0",
                padding: "0",
              },
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              backgroundColor: props.isLoadingDataCorretores
                ? "#cccccc"
                : "transparent",
            }}
            disabled={props.isLoadingDataCorretores}
            disablePortal
            id="combo-box-demo"
            options={corretoresOptions?.data?.map(
              (item: { nome: string; idCorretor: string }) => {
                return {
                  label: item?.nome,
                  value: item?.idCorretor,
                };
              }
            )}
            size="small"
            renderInput={(params: any) => (
              <TextField
                {...params}
                placeholder={
                  props.isLoadingDataCorretores ? "Aguarde..." : "Corretor *"
                }
                fullWidth
              />
            )}
            value={corretor}
            onChange={(_, newValue: any) => {
              setCorretor(newValue);
            }}
            inputValue={inputCorretorValue}
            onInputChange={(_, newInputValue) => {
              setInputCorretorValue(newInputValue);
            }}
          />
        </div>
      </Styles.Bar>
      <Styles.SearchButton
        disabled={props?.disabled}
        onClick={() => (props?.disabled ? {} : handleSendForm())}
      >
        <p>Procurar</p>
      </Styles.SearchButton>
    </Styles.Section>
  );
};

export default FormHorizontalSearch;
